import { product2ShoppingProduct } from 'redux-store/products/products.utils';
import { type IShoppingProductsMap, QUERY_PARAMS } from 'utils/constants';
import getQueryParam from 'utils/getQueryParam';
import { getServiceSettings } from 'utils/getServiceSettings';
import { getDexfSegment, isProduction } from 'utils/platform';

import { ProductOptionalFieldNameEnum } from '@inter-ikea-kompis/enums';
import { ProductService } from '@inter-ikea-kompis/services';
import type { IProduct } from '@inter-ikea-kompis/types';

let service: ProductService;

const getService = () => {
  if (!service) {
    service = new ProductService(getServiceSettings());
  }

  return service;
};

const getOptionalParams = () => {
  const futureDate = (!isProduction() && getQueryParam(QUERY_PARAMS.FUTURE_DATE)) || '';
  const segment = getDexfSegment();

  return {
    customParams: {
      timestamp: futureDate,
      'filter.segment': segment,
    },
  };
};

const getProductsData: () => Promise<IProduct[]> = () => {
  return getService().getApplicationProducts(Object.values(ProductOptionalFieldNameEnum), getOptionalParams());
};

const normalizedObject = (products: IProduct[]) => {
  return products.reduce<IShoppingProductsMap>((acc, product) => {
    acc[product.itemId] = product2ShoppingProduct(product);
    return acc;
  }, {});
};

export const getProducts = async () => {
  const products = await getProductsData();

  return normalizedObject(products);
};
